import { DefaultButton } from "@medforall/medforall-component-library";

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  title?: string;
}

const ExternalLink = ({ href, children, className = "", title }: ExternalLinkProps) => {
  return (
    <a 
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={title || 'Click me'}
      className="tw-text-dark hover:tw-text-primary-dark tw-flex"
    >
      <DefaultButton tag="span" className={`tw-text-inherit tw-text-in tw-w-full tw-pl-60px ${className}`} childClasses="tw-text-inherit">
        <span className="tw-text-inherit tw-text-in tw-text-left tw-justify-start tw-flex-grow tw-w-full">
          {children || "Click me"}
        </span>
      </DefaultButton>
    </a>
  );
};

export default ExternalLink; 